import { IPayoutHistoryReportState } from './types';
import { IPayoutHistoryReportItem, PaginationResponse } from '@ready/dashboardv2api.contracts';
import { IPagedResponse } from '@ready/table.core';
import { ILocation } from '../../../services/types/ILocation.type';

export const fetchPayoutHistoryReportReducers = {
  pending: (state: IPayoutHistoryReportState) => {
    state.loading.list = true;
  },
  fulfilled: (
    state: IPayoutHistoryReportState,
    action: { payload: PaginationResponse<IPayoutHistoryReportItem> }
  ) => {
    const { items, total, limit, start, length } = action.payload;
    state.loading.list = false;
    state.items = items;
    state.pagination = { total, limit, start, length };
  },
  rejected: (state: IPayoutHistoryReportState) => {
    state.loading.list = false;
    state.errors.list = 'Unable to retrieve Promo Code Summary list.';
    state.items = [];
  },
};

export const fetchPermittedLocationsReducers = {
  pending: (state: IPayoutHistoryReportState) => {
    state.loading.permittedLocations = true;
  },
  fulfilled: (state: IPayoutHistoryReportState, action: { payload: IPagedResponse<ILocation> }) => {
    state.loading.permittedLocations = false;
    state.permittedLocations = action.payload;
  },
  rejected: (state: IPayoutHistoryReportState) => {
    state.loading.permittedLocations = false;
  },
};
